function blockIPs() {
    $.getJSON("https://api.ipify.org?format=json", (function(t) {
        let e = t && t.ip;
        -1 != ["45.79.3.55", "213.139.193.38", "92.119.163.194", "50.116.47.53", "216.244.77.45", "45.154.59.196", "45.130.126.30", "193.36.231.4", "195.208.3.166", "45.152.138.48", "24.9.193.84", "212.193.140.127", "96.80.211.134", "62.76.153.47", "174.239.81.6", "45.87.125.234", "154.13.41.72", "172.56.209.210"].indexOf(e) && $("body").html("Checking BOT!")
    }
    ))
}
$((function() {
    document.documentElement.style.setProperty("--vh", window.innerHeight / 100 + "px"),
    refreshMiniCart(),
    blockIPs()
}
));
var bundle_map = {
    46620505178426: "46620523594042",
    47006767644986: "47006767677754"
}
  , bundle_items = [46620523594042, 47006767677754];
function formatMoney(t, e) {
    "string" == typeof t && (t = t.replace(".", ""));
    var a = ""
      , i = /\{\{\s*(\w+)\s*\}\}/
      , n = "${{amount}}";
    function s(t, e) {
        return void 0 === t ? e : t
    }
    function r(t, e, a, i) {
        if (e = s(e, 2),
        a = s(a, ","),
        i = s(i, "."),
        isNaN(t) || null == t)
            return 0;
        var n = (t = (t / 100).toFixed(e)).split(".");
        return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? i + n[1] : "")
    }
    switch (n.match(i)[1]) {
    case "amount":
        a = r(t, 2);
        break;
    case "amount_no_decimals":
        a = r(t, 0);
        break;
    case "amount_with_comma_separator":
        a = r(t, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        a = r(t, 0, ".", ",")
    }
    return n.replace(i, a)
}
function openMiniCart() {
    $(".product-sticky-mobile").addClass("sticky-open")
}
function closeMiniCart() {
    $(".product-sticky-mobile").hasClass("sticky-open") ? $(".product-sticky-mobile").removeClass("sticky-open") : $(".product-sticky-mobile").addClass("sticky-open")
}
function refreshCartContent(t) {
    let e = ""
      , a = 4500
      , i = "";
    for (let a = 0; a < t.items.length; a++) {
        let n, s, r, o = t.items[a], l = -1 != bundle_items.indexOf(o.id), c = o.featured_image.url, d = l ? 2 * o.variant_title : o.variant_title, p = o.product_title;
        console.log(o),
        o.variant_title && o.variant_title.search("Pack") < 0 && (d += " Count Box"),
        c.includes(".jpg") ? (n = c.split(".jpg")[0],
        s = c.split(".jpg")[1],
        r = n + "_100x100.jpg" + s) : (n = c.split(".png")[0],
        s = c.split(".png")[1],
        r = n + "_100x100.png" + s),
        l && (p = p.replace(" 12ct", ""),
        p = p.replace(" 16ct", ""),
        p = p.replace(" 9ct", "")),
        i += `\n      <div class="cart-mini-item">\n        <div class="cart-mini-item-image">\n          <img src="${r}" alt="${o.title}">\n        </div>\n        <div class="cart-mini-item-body">\n          <div class="cart-mini-item-title">${p}</div>`,
        o.selling_plan_allocation && o.selling_plan_allocation.selling_plan && (i += `\n        <div class="cart-mini-delivery-frequency">Deliver Every ${o.selling_plan_allocation.selling_plan.name}</div>\n      `),
        i += `<div class="cart-mini-count-box">${d}</div>\n   ${o.line_level_discount_allocations.length ? `<div class="cart__line-discount"><span class="discount__icon"><svg class="icon icon-discount" viewBox="0 0 12 12">
        <path fill="currentColor" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"/>
        </svg></span><span class="discount__title">${o.line_level_discount_allocations[0].discount_application.title}</span></div>` : ""}       <div class="cart-mini-quantity">\n            <span class="input-group-btn">\n              <button class="quantity-left-minus btn btn-number`,
        l && (i += " bundle"),
        i += `" data-type="minus" data-field="" data-id="${o.id}" data-qty="${o.quantity}" data-line-id="${a + 1}">-</button>\n            </span>\n            <input type="text" name="quantity" class="product-qty-number input"  value="${l ? o.quantity / 2 : o.quantity}" readonly>\n            <span class="input-group-btn">\n              <button class="quantity-right-plus btn btn-number`,
        l && (i += " bundle"),
        i += `" data-type="plus" data-field="" data-id="${o.id}" data-qty="${o.quantity}" data-line-id="${a + 1}">+</button>\n            </span>\n          </div>\n        </div>\n        <div class="cart-mini-item-footer">\n          <div class="cart-mini-item-close">\n            <div class="btn-cart-mini-item-close" href="javascript:void(0);" data-id="${o.id}" data-qty="${o.quantity}" data-line-id="${a + 1}" ><span>&times;</span></div>\n          </div>\n          <div class="cart-mini-item-price">\n            <span>${formatMoney(o.final_line_price)}</span>\n          </div>\n        </div>\n      </div>\n    `;
        for (let t = 0; t < o.quantity; t++)
            e += `<div class="product-sticky-item">\n                    <div class="product-image__wrapper">\n                      <img src="${r}" alt="${o.title}" />\n                    </div>\n                    <a href="javascript:void(0);" class="item-remove" title="Remove" data-id="${o.id}" data-qty="${o.quantity}" data-line-id="${a + 1}">\n                      <span class="sr-only">Remove</span>\n                    </a>\n                  </div>`
    }
    if ($(".product-sticky-cart-list").html(e),
    $(".cart-mini-content-inner").html(i),
    $(".product-sticky-product-counts .num_counts").html(t.item_count),
    $(".cart-count-bubble").html(`<span aria-hidden="true">${t.item_count}</span>\n     <span class="visually-hidden">${t.item_count} item</span>`),
    t.total_price,
    "0" == t.total_price ? ($(".product-button .btn.btn-primary.cart-link").html("<span>View Cart</span>"),
    $(".cart-mini-subtotal-money-value").html("0.00")) : ($(".product-button .btn.btn-primary.cart-link").html(`<span class="total-price">${formatMoney(t.total_price)}</span> &nbsp;&nbsp;<span>Proceed to Cart</span>`),
    $(".cart-mini-subtotal-money-value").html(`${formatMoney(t.total_price)}`.replace("$", ""))),
    t.total_price > a)
        $(".freeshipping_motivation").html("Congrats! 🎉 You’ve earned <b>FREE SHIPPING</b>!"),
        $(".product-sticky-progressbar").css("width", "100%");
    else {
        var n = t.total_price / a * 100;
        $(".freeshipping_motivation").html(`You are only <b>${formatMoney(a - t.total_price)}</b> away from <b>FREE SHIPPING!`),
        $(".product-sticky-progressbar").css("width", n + "%")
    }
}
function refreshMiniCart() {
    $.Deferred();
    const t = $.get("/cart.js", (t => {
        refreshCartContent(t)
    }
    ), "json");
    return $.when(t)
}
function ajaxUpdateCart(t, e) {
    $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: !1,
        type: "post",
        data: {
            quantity: e,
            line: t
        },
        success: function(t) {
            refreshCartContent(t)
        }
    })
}
function slick() {
    $((function() {
        var t, e;
        return t = $(".slider-options .option"),
        e = $("#gallery .slider"),
        t.on("click", (function() {
            var a, i;
            return a = (i = $(this)).attr("slide"),
            t.removeClass("is-active"),
            e.slick("slickGoTo", a),
            i.addClass("is-active")
        }
        ))
    }
    ))
}
function changeURL(t, e) {
    window.history.pushState({
        html: $("html").html(),
        pageTitle: t
    }, "", e)
}
function doScrolling(t, e) {
    const a = window.pageYOffset
      , i = t - a;
    let n;
    window.requestAnimationFrame((function t(s) {
        n || (n = s);
        const r = s - n
          , o = Math.min(r / e, 1);
        window.scrollTo(0, a + i * o),
        r < e && window.requestAnimationFrame(t)
    }
    ))
}
function clearCartPage() {
    return console.log("clearing cart"),
    $.ajax({
        type: "POST",
        async: "false",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function() {},
        error: function(t, e) {}
    })
}
async function getCartPage() {
    let t = await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }
    });
    return await t.json()
}
async function addSubscriptions() {
    getCartPage().then((async t => {
        console.log(t, "item data");
        let e = await fetch(window.Shopify.routes.root + "cart/clear.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: ""
        });
        console.log("clear response", e);
        let a = [];
        a = t.items;
        let i = []
          , n = {
            shipping_interval_unit_type: "Days",
            shipping_interval_frequency: $('.rc_shipping_interval_frequency_option input[name="properties[shipping_interval_frequency]"]:checked').val()
        };
        if (0 == a.length)
            return console.log("no cart item after get cart.json"),
            void $("#preloader").css("display", "none");
        for (let t = 0; t < a.length; t++) {
            let e, s = a[t];
            "autodeliver" == radio_value && (e = variants_map[s.id],
            console.log(s, e),
            e ? i.push({
                quantity: s.quantity,
                id: e,
                properties: n
            }) : i.push({
                quantity: s.quantity,
                id: s.id,
                properties: n
            }),
            $("#checkout_btn").addClass("recharge-checkout")),
            "onetime" == radio_value && (e = d_variants_map[s.id],
            console.log(s, e),
            e ? i.push({
                quantity: s.quantity,
                id: e
            }) : i.push({
                quantity: s.quantity,
                id: s.id
            }),
            $("#checkout_btn").removeClass("recharge-checkout"))
        }
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                items: i
            },
            success: t => {
                refreshCartPage(t),
                $("#checkout_btn").attr("disabled", !1)
            }
            ,
            error: t => {
                $("#preloader").css("display", "none")
            }
            ,
            dataType: "json"
        })
    }
    ))
}
function updateSubscriptionFrequency(t) {
    getCartPage().then((async e => {
        console.log(e, "item data");
        let a = await fetch(window.Shopify.routes.root + "cart/clear.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: ""
        });
        console.log("clear response", a);
        let i = [];
        i = e.items,
        console.log(i, t);
        let n = []
          , s = {
            shipping_interval_unit_type: "Days",
            shipping_interval_frequency: t
        };
        if (0 == i.length)
            return console.log("no cart item after get cart.json"),
            void $("#checkout_btn").attr("disabled", !1);
        for (let t = 0; t < i.length; t++) {
            let e = i[t];
            n.push({
                quantity: e.quantity,
                id: e.id,
                properties: s
            })
        }
        console.log(n),
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
                items: n
            },
            success: t => {
                refreshCartPage(t),
                $("#checkout_btn").attr("disabled", !1)
            }
            ,
            dataType: "json"
        })
    }
    ))
}
function ajaxUpdateCartPage(t, e) {
    $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: !1,
        type: "post",
        data: {
            quantity: e,
            line: t
        },
        success: function(t) {
            refreshCartPage(t)
        }
    })
}
function refreshCartPage() {
    $.Deferred();
    const t = $.get("/cart.js", (t => {
        refreshCartPageItems(t),
        $("#preloader").css("display", "none")
    }
    ), "json");
    return $.when(t)
}
function refreshCartPageItems(t) {
    let e = ""
      , a = !1;
    for (let i = 0; i < t.items.length; i++) {
        let n = t.items[i]
          , s = -1 != bundle_items.indexOf(n.id);
        console.log("is_bundle", s);
        let r, o, l, c = n.featured_image.url, d = n.product_title;
        n.product_title.includes("Auto renew") && (d = n.product_title.replace(" 20.00% Off Auto renew", ""),
        d = n.product_title.replace(" 10.00% Off Auto renew", ""),
        a = !0),
        s && (d = d.replace(" 12ct", ""),
        d = d.replace(" 16ct", "")),
        c.includes(".jpg") ? (r = c.split(".jpg")[0],
        o = c.split(".jpg")[1],
        l = r + "_200x200.jpg" + o) : (r = c.split(".png")[0],
        o = c.split(".png")[1],
        l = r + "_200x200.png" + o),
        e += `<div class="cart-item" id="CartItem-${i}">\n                  <div class="cart-item__media">\n                      <a href="javascript:void(0);" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>\n                        <div class="cart-item__image-container gradient global-media-settings">\n                          <img src="${l}"\n                            class="cart-item__image"\n                            alt="${n.title}"\n                            loading="lazy"\n                            width="150"\n                            height="auto"\n                          >\n                        </div>\n                  </div>\n                  <div class="cart-item__details">\n                    <a href="javascript:void(0);" class="cart-item__name h4 break" tabindex="-1">${d}</a>\n                    <div class="product-option item-price">\n                      ${formatMoney(n.final_price)}\n                    </div>\n                  </div>\n                  <div class="cart-input-wrapper input-wrapper">\n                    <div class="input-group input-qty" style="position: relative;">\n                      <span class="input-group-btn">\n                        <button type="button" class="quantity-left-minus btn btn-number`,
        s && (e += " bundle"),
        e += `" data-type="minus" data-field="" tabindex="-1" data-id="${n.id}" data-qty="${n.quantity}" data-line-id="${i + 1}">\n                          <span>-</span>\n                          <span></span>\n                        </button>\n                      </span>\n                      <input type="text" name="quantity" class="product-qty-number input" value="${s ? n.quantity / 2 : n.quantity}" tabindex="-1" readonly><span class="ot_valid_product"></span>\n                      <span class="input-group-btn">\n                        <button type="button" class="quantity-right-plus btn btn-number`,
        s && (e += " bundle"),
        e += `" data-type="plus" data-field="" tabindex="-1" data-id="${n.id}" data-qty="${n.quantity}" data-line-id="${i + 1}">\n                          <span>+</span>\n                        </button>\n                      </span>\n                    </div>\n                    <a href="javascript:void(0);" class="item-remove" title="Remove" data-id="${n.id}" data-qty="${n.quantity}" data-line-id="${i + 1}" tabindex="-1">\n                      <span class="sr-only">Remove</span>\n                    </a>\n                  </div>\n                </div>\n                `
    }
    if (e)
        $(".cart-items").html(e),
        a ? ($("#rc_price_onetime_cart").html(formatMoney(t.total_price / .8)),
        $("#rc_price_autodeliver_cart").html(formatMoney(t.total_price))) : ($("#rc_price_onetime_cart").html(formatMoney(t.total_price)),
        $("#rc_price_autodeliver_cart").html(formatMoney(.8 * t.total_price))),
        $(".totals__subtotal-value").html(formatMoney(t.total_price));
    else {
        let t = '<div class="cart__warnings">\n                        <h1 class="cart__empty-text">Your cart is empty</h1>\n                        <a href="/collections/all" class="button">\n                          Continue shopping\n                        </a><h2 class="cart__login-title">Have an account?</h2>\n                          <p class="cart__login-paragraph">\n                            <a href="/account/login" class="link underlined-link">Log in</a> to check out faster.\n                          </p>\n                      </div>';
        $("cart-items").addClass("is-empty").html(t),
        $("#main-cart-footer").css("display", "none"),
        $("#MainContent").addClass("is-empty")
    }
    $(".cart-count-bubble").html(`<span aria-hidden="true">${t.item_count / 2}</span>\n     <span class="visually-hidden">${t.item_count / 2} item</span>`)
}
function toggleSubscription() {
    $(".cart-items .cart-item").each((function() {
        let t = $(this).find(".cart-item__details").data("variants");
        if (console.log(t, "v_map"),
        t)
            for (const e in t)
                variants_map[e] = t[e].discount_variant_id,
                d_variants_map[t[e].discount_variant_id] = e
    }
    ))
}
String.prototype.handleize = function() {
    str = this.toLowerCase();
    for (var t = ['"', "'", "\\", "(", ")", "[", "]"], e = 0; e < t.length; ++e)
        str = str.replace(t[e], "");
    return str = str.replace(/\W+/g, "-"),
    "-" == str.charAt(str.length - 1) && (str = str.replace(/-+\z/, "")),
    "-" == str.charAt(0) && (str = str.replace(/\A-+/, "")),
    str
}
,
window.matchMedia("(max-width: 767px)").matches && ($(window).on("resize", (function() {
    window.innerHeight > 767 && document.documentElement.style.setProperty("--vh", window.innerHeight / 100 + "px")
}
)),
$(".press-slider").slick({
    autoplay: !0,
    draggable: !0,
    prevArrow: '<img class="slick-prev lazyload" data-src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image" >',
    nextArrow: '<img class="slick-next lazyload" data-src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image" >'
}),
$(".feature-mobile__slider .feature_item img").each((function() {
    $(this).removeClass("lazyload")
}
)),
$(".feature-mobile__slider").slick({
    lazyLoad: "ondemand",
    autoplay: !0,
    draggable: !0,
    slidesToShow: 1,
    prevArrow: '<img class="lazyload slick-prev" data-src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image">',
    nextArrow: '<img class="lazyload slick-next" data-src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image">'
}),
$("#verified-reviews_slider").slick({
    autoplay: !0,
    draggable: !0,
    prevArrow: '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image">',
    nextArrow: '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image">'
}),
$(".feature-mobile__slider").css("display", "flex"),
$(".crosssell-mobile__slider").slick({
    autoplay: !0,
    draggable: !0,
    prevArrow: '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image">',
    nextArrow: '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image">'
}),
$(".cart__footer-container").hasClass("sticky_footer") || ($(".cart__footer-container").removeClass("unsticky_footer"),
$(".cart__footer-container").addClass("sticky_footer"))),
$(".testimonial").slick({
    autoplay: !0,
    draggable: !0,
    prevArrow: '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image">',
    nextArrow: '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image">'
}),
$(".brand-slider").slick({
    lazyLoad: "ondemand",
    autoplay: !0,
    draggable: !0,
    dots: !0,
    slidesToShow: 1,
    prevArrow: '<img class="lazyload slick-prev" src="https://cdn.shopify.com/s/files/1/0258/6121/files/slider-prev.svg?v=1687863112" width="20" alt="left image">',
    nextArrow: '<img class="lazyload slick-next" src="https://cdn.shopify.com/s/files/1/0258/6121/files/slider-next.svg?v=1687863103" width="20" alt="right image">'
}),
$(".slideToggle").click((function() {
    $(this).toggleClass("btn-active"),
    $(".nutrition--open").slideToggle()
}
)),
$(".flavor-mobile__toggle").click((function() {
    $(".flavor-mobile__content").slideToggle()
}
)),
$(".nutrition__toggle").click((function() {
    $(".nutrition__content").slideToggle()
}
)),
$(".customer-content__slider").slick({
    centerMode: !0,
    autoplay: !0,
    autoplaySpeed: 1e3,
    speed: 1e3,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: !1,
    dots: !1,
    pauseOnDotsHover: !0,
    cssEase: "linear",
    draggable: !1,
    arrows: !1,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: !1,
            centerMode: !0,
            centerPadding: "40px",
            slidesToShow: 3
        }
    }, {
        breakpoint: 480,
        settings: {
            arrows: !1,
            centerMode: !0,
            centerPadding: "40px",
            slidesToShow: 1
        }
    }]
}),
$(document).ready((function() {
    $("body").on("click", ".product-button .add-to-cart", (function(t) {
        t.preventDefault();
        let e = $(this).data("id")
          , a = 1
          , i = $(this).parents(".product-cart").find(".product-qty-number");
        i.length && (a = i.hasClass("input") ? i.val() : i.text());
        let n = i.hasClass("input") ? $(this).parents("form").serializeArray() : {
            id: e,
            quantity: a
        };
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: n,
            success: () => {
                console.log("success"),
                refreshMiniCart(),
                $(".popup__overlay .popup__close").click()
            }
            ,
            error: function(t, e, a) {},
            dataType: "json"
        }),
       open_mini_cart()
        this.setAttribute("data-added", "true");
    }
    )),
    $("body").on("click", ".product-button .pdp-add-to-cart", (function(t) {
        t.preventDefault();
        let e = $(this).data("id");
        console.log(e, "adding to cart");
        let a = 1
          , i = $(this).parents(".product-cart").find(".product-qty-number");
        i.length && (a = i.hasClass("input") ? i.val() : i.text());
        let n = i.hasClass("input") ? $(this).parents("form").serializeArray() : {
            id: e,
            quantity: a
        };
        n[0].value && bundle_map[n[0].value] && (n[0].value = bundle_map[n[0].value],
        n[3].value = 2 * n[3].value);
        let s = $(this).parents("form").find('#rc_radio_options input[name="purchase_type"]:checked').val()
          , r = $('.product-deliver-every input[type="radio"]:checked').val()
          , o = [];
        if ("autodeliver" == s) {
            o = n;
            let t = 0;
            o.forEach((function(e) {
                "properties[shipping_interval_frequency]" == e.name && (e.value = r),
                "id" == e.name && bundle_map[e.value] && (t = e.value,
                e.value = bundle_map[e.value]),
                "quantity" == e.name && bundle_map[t] && (e.value = 2 * e.value)
            }
            ))
        } else
            n.forEach((function(t) {
                "properties[shipping_interval_frequency]" == t.name || "properties[delivery_frequency]" == t.name || "purchase_type" == t.name || o.push(t)
            }
            ));
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: o,
            success: () => {
                console.log("success"),
                refreshMiniCart(),
                setTimeout(( () => {
                    open_mini_cart()
                }
                ), 200)
            }
            ,
            error: function(t, e, a) {},
            dataType: "json"
        })
    }
    )),
    $("body").on("click", ".product-cart .btn.btn-number", (function(t) {
        let e = "plus" == $(this).data("type")
          , a = $(this).parents(".product-cart").find(".product-qty-number")
          , i = a.hasClass("input") ? parseInt(a.val()) : parseInt(a.text())
          , n = e ? $(this).parents(".input-group").find(".quantity-left-minus") : $(this);
        e ? (a.text(i + 1),
        a.val(i + 1),
        n.attr("disabled", !1)) : 1 != i ? (a.text(i - 1),
        a.val(i - 1)) : $(this).attr("disabled", !0)
    }
    )),
    $("body").on("click", ".product-collections-item .open-product-popup", (function(t) {
        let e = $(this).data("id")
          , a = $(this).data("image")
          , i = $(this).data("available")
          , n = $(this).data("product-url");
        fetch(n).then((t => t.text())).then((t => {
            const s = (new DOMParser).parseFromString(t, "text/html");
            let r = s.querySelector('media-gallery[id^="MediaGallery-template-"]')
              , o = r.querySelectorAll(".product__media.media.media--transparent.gradient")
              , l = 0;
            o.forEach((function(t, e) {
                let a = t.querySelector("img");
                $(a).attr("src");
                "nutrition image" == $(a).attr("alt") && (l = e)
            }
            ));
            let c = s.querySelector(".product__title .left-wrapper")
              , d = s.querySelector(".product__title .jdgm-prev-badge__text");
            $("#popup-product .product__media-content #MediaGallery-popup-product").html(r),
            $("#popup-product .product__media-content #MediaGallery-popup-product ul li.thumbnail-list__item button").eq(l).trigger("click"),
            $("#popup-product .product__title .left-wrapper").html(c.innerHTML),
            $("#popup-product .product__title .jdgm-prev-badge__text").html(d.innerHTML),
            $("#popup-product .product__title .product__text .product-review-link").data("review-link", n + "#judgeme_product_reviews"),
            $("#popup-product .add-to-cart").data("id", e),
            i || $("#popup-product .product-button").css("display", "none"),
            a && $("#popup-product .product__info-wrapper .nutrition_image").attr("src", a)
        }
        )).finally(( () => {
            console.log("finally"),
            $(".popup__overlay").addClass("open")
        }
        ))
    }
    )),
    $("body").on("click", ".popup__overlay .popup__close", (function(t) {
        $(".popup__overlay").removeClass("open")
    }
    )),
    $("body").on("click", ".popup__overlay .product-review-link", (function(t) {
        return t.preventDefault(),
        console.log("redirecting.."),
        window.location = $(this).data("review-link"),
        !1
    }
    )),
    $("body").on("click", ".mini-cart .item-remove", (function(t) {
        let e = $(this).data("qty");
        ajaxUpdateCart($(this).data("line-id"), e - 1)
    }
    )),
    $(".down-arrow-icon-box").on("click", (function(t) {
        doScrolling(900, 500)
    }
    ));
    var t = $(".step-featured__gallery").slick({
        arrows: !1,
        slideToShow: 1,
        asNavFor: ".step-thumbnail__gallery,.step-text__gallery"
    })
      , e = ($(".step-text__gallery").slick({
        arrows: !0,
        asNavFor: ".step-thumbnail__gallery,.step-featured__gallery",
        prevArrow: '<img class="slick-prev" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-left.svg?v=1587493414" width="20" alt="left image">',
        nextArrow: '<img class="slick-next" src="https://cdn.shopify.com/s/files/1/0258/6121/files/press-arrow-right.svg?v=1587493414" width="20" alt="right image">'
    }),
    parseInt($(".step-thumbnail__gallery").data("num")));
    !e && (e = 10);
    var a = $(".step-thumbnail__gallery").slick({
        arrows: !1,
        asNavFor: ".step-featured__gallery,.step-text__gallery",
        dots: !1,
        focusOnSelect: !0,
        slidesToShow: e,
        responsive: [{
            breakpoint: 1230,
            settings: {
                slidesToShow: e
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1
            }
        }]
    });
    t.on("afterChange", (function(e, i, n, s) {
        let r = t.slick("slickCurrentSlide");
        a.slick("slickGoTo", r),
        $(".step-thumbnail__gallery .slick-slide.slick-active.slick-current").removeClass("slick-current"),
        $(".step-thumbnail__gallery .slick-slide.slick-active").eq(r).addClass("slick-current")
    }
    ));
    var i = $("#variant-flavor")
      , n = i.find("li");
    function s() {
        radio_value = $('#rc_radio_options input[name="purchase_type"]:checked').val();
        let t = 0
          , e = null
          , a = 0;
        "autodeliver" == radio_value ? ($("#addtocartform .product-deliver-every").css("display", "block"),
        e = $("#addtocartform .rc_price__autodeliver")) : ($("#addtocartform .product-deliver-every").css("display", "none"),
        e = $("#addtocartform .rc_price__onetime")),
        t = parseFloat(e.html().replace("$", "")),
        a = parseInt($("#addtocartform .product-qty-number").val()),
        $("#addtocartform .product-total-price").html(`${formatMoney(100 * t * a)}`)
    }
    $(document).on("click", "#variant-flavor span", (function() {
        $("#variant-flavor").addClass("active")
    }
    )),
    n.click((function(t) {
        t.preventDefault();
        let e = $(this);
        e.addClass("active").siblings().removeClass("active"),
        window.location.href = e.attr("data-url")
    }
    )),
    $(document).click((function(t) {
        !$(t.target).closest("#variant-flavor").length && i.hasClass("active") && i.removeClass("active")
    }
    )),
    $(document).on("click", ".menu-drawer__menu-label", (function() {
        let t = $(this).data("id");
        $(".menu-drawer__menu-label").each((function(e) {
            let a = $(this).data("id");
            t == a ? $(this).hasClass("menu-open") ? $(this).removeClass("menu-open") : $(this).addClass("menu-open") : ($(this).removeClass("menu-open"),
            $("#" + a).prop("checked", !1))
        }
        ))
    }
    )),
    $(document).on("click", ".menu-drawer__submenu-label", (function() {
        let t = $(this).data("id");
        $(".menu-drawer__submenu-label").each((function(e) {
            let a = $(this).data("id");
            t == a ? $(this).hasClass("menu-open") ? $(this).removeClass("menu-open") : $(this).addClass("menu-open") : ($(this).removeClass("menu-open"),
            $("#" + a).prop("checked", !1))
        }
        ))
    }
    )),
    $("body").on("click", ".cart-input-wrapper .btn.btn-number", (function(t) {
        let e = "plus" == $(this).data("type")
          , a = $(this).parents(".cart-input-wrapper").find(".product-qty-number")
          , i = a.hasClass("input") ? parseInt(a.val()) : parseInt(a.text())
          , n = e ? $(this).parents(".input-group").find(".quantity-left-minus") : $(this)
          , s = i
          , r = $(this).data("line-id");
        e ? (a.text(i + 1),
        a.val(i + 1),
        n.attr("disabled", !1),
        s = i + 1) : 1 != i ? (a.text(i - 1),
        a.val(i - 1),
        s = i - 1) : ($(this).attr("disabled", !0),
        s = 0),
        $(this).hasClass("bundle") && (s *= 2),
        ajaxUpdateCartPage(r, s)
    }
    )),
    $('#rc_radio_options input[name="purchase_type"]').on("change", (function(t) {
        s()
    }
    )),
    $(document).on("click", "#addtocartform .btn-number", (function() {
        s()
    }
    )),
    $('#rc_cart_radio_options input[name="purchase_type"]').on("change", (function(t) {
        $("#checkout_btn").attr("disabled", !0),
        radio_value = $('#rc_cart_radio_options input[name="purchase_type"]:checked').val(),
        $("#rc_cart_radio_options .rc_block__type").removeClass("rc_block__type--active"),
        $(`#rc_cart_radio_options .rc_block__type__${radio_value}`).addClass("rc_block__type--active"),
        "autodeliver" == radio_value ? $("#deliver_cart_step").css("display", "block") : $("#deliver_cart_step").css("display", "none"),
        toggleSubscription(),
        $("#preloader").css("display", "block"),
        addSubscriptions()
    }
    )),
    $('#deliver_cart_step input[name="properties[shipping_interval_frequency]"]').on("change", (function(t) {
        $("#checkout_btn").attr("disabled", !0),
        $("#preloader").css("display", "block");
        let e = $('#deliver_cart_step input[name="properties[shipping_interval_frequency]"]:checked').val();
        "onetime" != radio_value && updateSubscriptionFrequency(e)
    }
    )),
    $("body").on("click", ".cart-input-wrapper .item-remove", (function(t) {
        $(this).data("qty");
        ajaxUpdateCartPage($(this).data("line-id"), 0)
    }
    )),
    $("body").on("click", "#checkout_btn", (function(t) {
        console.log("hey"),
        t.preventDefault(),
        t.stopPropagation(),
        $.get("/cart.js", (t => {
            var e = "&cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2];
            if (t.indexOf("shipping_interval_frequency") > -1) {
                try {
                    var a = "&" + ga.getAll()[0].get("linkerParam")
                } catch (t) {
                    a = ""
                }
                window.location = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=rip-van-wafels.myshopify.com" + e + a
            } else
                window.location = "/checkout"
        }
        ), "text")
    }
    ))
}
)),
$(".select__input.faq__title").on("click", (function(t) {
    $(this).toggleClass("is-active"),
    $(this).parent(".faq-select.faq").toggleClass("is-active"),
    $(this).siblings(".select__list.faq__content").toggle()
}
)),
$(document).on("click", ".product-initial", (function() {
    $(".product-sticky-mobile").addClass("sticky-open")
}
)),
$(document).on("click", ".product-sticky-mobile .sticky-btn-open-close", (function() {
    $(".product-sticky-mobile").hasClass("sticky-open") ? $(".product-sticky-mobile").removeClass("sticky-open") : $(".product-sticky-mobile").addClass("sticky-open")
}
));
var $w = $(window).scroll((function() {
    $w.scrollTop() > 100 ? ($("#shopify-section-header").addClass("shopify-section-header-sticky-new"),
    $(".product-sticky").addClass("sticky-add")) : ($("#shopify-section-header").removeClass("shopify-section-header-sticky-new"),
    $(".product-sticky").removeClass("sticky-add"));
    var t = $(window).height() + $w.scrollTop() + $("footer")[0].offsetHeight
      , e = $("body.gradient")[0].offsetHeight;
    $(".cart__footer-container").hasClass("unsticky_footer") && (e = $("body.gradient")[0].offsetHeight - $(".cart__footer")[0].offsetHeight),
    t < e - 5 ? ($(".cart__footer-container").addClass("sticky_footer"),
    $(".cart__footer-container").removeClass("unsticky_footer")) : ($(".cart__footer-container").removeClass("sticky_footer"),
    $(".cart__footer-container").addClass("unsticky_footer"))
}
));
function open_mini_cart() {
    //$("html").addClass("scroll-locked"),
    //$(".cart-mini").addClass("cart-mini-open")
}
function close_mini_cart() {
    $("html").removeClass("scroll-locked"),
    $(".cart-mini").removeClass("cart-mini-open")
}
$(document).ready((function() {
    $(document).on("click", ".btn-mini-cart", (function() {
        open_mini_cart()
    }
    )),
    $(document).on("click", ".cart-mini-open .cart-mini-close", (function() {
        close_mini_cart()
    }
    )),
    $(document).on("click", ".cart-mini-open", (function(t) {
        $(".cart-mini-sidebar").is(t.target) || 0 != $(".cart-mini-sidebar").has(t.target).length ? t.stopPropagation() : close_mini_cart()
    }
    )),
    $(document).on("click", ".cart-mini-item .btn-cart-mini-item-close", (function(t) {
        $(this).data("qty");
        ajaxUpdateCart($(this).data("line-id"), 0)
    }
    )),
    $(document).on("click", ".cart-mini-quantity .btn-number", (function() {
        let t = "plus" == $(this).data("type")
          , e = $(this).parents(".cart-mini-quantity").find(".product-qty-number")
          , a = e.hasClass("input") ? parseInt(e.val()) : parseInt(e.text())
          , i = $(this).hasClass("bundle")
          , n = t ? $(this).parents(".cart-input-wrapper").find(".quantity-left-minus") : $(this)
          , s = i ? 2 * a : a
          , r = $(this).data("line-id")
          , o = i ? 2 : 1;
        i ? t ? (e.text((s + o) / 2),
        e.val((s + o) / 2)) : (e.text((s - o) / 2),
        e.val((s - o) / 2)) : t ? (e.text(s + o),
        e.val(s + o)) : (e.text(s - o),
        e.text(s - o)),
        t ? (n.attr("disabled", !1),
        s += o) : 1 != s ? s -= o : ($(this).attr("disabled", !0),
        s = 0),
        ajaxUpdateCart(r, s)
    }
    ))
}
));

/* Shop_all_custom_template_slider */
var $Shop_all_custom_template_slider = $('.Shop_all_custom_template_slider');
if ($Shop_all_custom_template_slider.length > 0) {
  new Swiper('.Shop_all_custom_template_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 12,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    observer: true,
    observeParents: true,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    freeMode: !0
  })
}

// Smooth scrolling
$(".Shop_all_custom_template_innerloops_mainboxs_new a").on("click", function(event) {
  if (this.hash !== "") {
    event.preventDefault();
    var hash = this.hash;
    var width = $(window).width();
    if (width >= 750) {
      $("html, body").animate({
          scrollTop: $(hash).offset().top - 120
      }, 400);
    }
    else
    {
      $("html, body").animate({
          scrollTop: $(hash).offset().top - 130
      }, 400);
    }
  }
});

var target = window.location.hash;
var hash = target.substring(target.indexOf('#') + 1);
if(hash)
{
  if($("#"+hash).length > 0){
    var width = $(window).width();
    if (width >= 750) {
      $("html, body").animate({
          scrollTop: $("#"+hash).offset().top - 180
      }, 400);
    }
    else
    {
      $("html, body").animate({
          scrollTop: $("#"+hash).offset().top - 130
      }, 400);
    }
  }
}

if($(".Shop_all_collection_block_main_new").length > 0)
{
  // Add active class on scroll
  $(window).on("scroll", function() {
    var scrollPosition = $(window).scrollTop();
    $(".Shop_all_collection_block_main_new").each(function() {
      var width = $(window).width();
      if (width >= 750) {
        var sectionTop = $(this).offset().top - 230;
      }
      else
      {
        var sectionTop = $(this).offset().top - 180;
      }
      var sectionBottom = sectionTop + $(this).outerHeight();
      console.log(scrollPosition +">="+ sectionTop +"&&"+ scrollPosition +"<"+ sectionBottom)
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          var currentId = $(this).attr("id");
          $(".Shop_all_custom_template_innerloops_mainboxs_new  a").removeClass("active");
          $(".Shop_all_custom_template_innerloops_mainboxs_new  a[href='#" + currentId + "']").addClass("active");
      }
    });
  });
}

if($(".Shop_all_custom_template_main_new").length > 0)
{
  var stickyHeaderTopSticky = $(".Shop_all_custom_template_main_new").offset().top;
  $(window).scroll(function(){
    if( $(window).scrollTop() > stickyHeaderTopSticky ) {
      if($('body').hasClass("fixed_collection_new") == false)
      {
          $('body').addClass('fixed_collection_new');
      }
    } else {
      $('body').removeClass('fixed_collection_new');
    }
  });
}

document.addEventListener('rebuy.add', function(event){
  console.log('rebuy.add event', event.detail);
  refreshMiniCart();
});

document.addEventListener('rebuy:cart.change', (event) => { 
  console.log('rebuy:cart.change event', event.detail);
  refreshMiniCart();
});

document.addEventListener('rebuy:smartsearch.quickview.add', (event) => {
  console.log(event.detail.product);
  console.log(event.detail.smartSearchQuickView);
  console.log("Quickview add");
    refreshMiniCart();
    setTimeout(( () => {
                open_mini_cart()
            }
            ), 200)
});

document.addEventListener('rebuy:smartsearch.resultsPage.add', (event) => {
  console.log(event.detail.product);
  console.log(event.detail.smartSearchResultsPage);
  console.log("Results Page Add");
  refreshMiniCart();
    setTimeout(( () => {
                open_mini_cart()
            }
            ), 200)
});

document.addEventListener('rebuy:smartsearch.quickview.ready', (event) => {
  console.log(event.detail.smartSearchQuickView, "Quickview is ready");
  if(document.querySelector('[js-header-search-icon]')) document.querySelector('[js-header-search-icon]').classList.add('active');
});

document.addEventListener('rebuy:smartcart.ready', (event) => {
  const smartcart = event.detail.smartcart;
  console.log('rebuy:smartcart.ready: smartcart', smartcart);
  if(document.querySelector('[js-cart-icon]')) document.querySelector('[js-cart-icon]').classList.remove('btn-disabled');
});

$(document).on("change", "#switchToSubscription", async function () {
  const isSub = $(this).is(":checked");

  console.log('is sub', isSub);

  // const cart = await Rebuy.Cart.getCart();

   // Show loading state
  document.getElementById('cart-loading-overlay').style.display = 'block';

   // Show overlay immediately
  document.getElementById('cart-loading-overlay').style.display = 'flex';
  
  // Hide native cart elements
  document.body.classList.add('hide-drawer');
  
  // Refresh happening.
  if (isSub) {
    await Rebuy.Cart.switchCartToFrequency({
      frequency: 30,
      interval: 'days'
    }, function() {
        // document.getElementById('cart-loading-overlay').style.display = 'none';
        // Keep overlay visible briefly after completion
        setTimeout(() => {
          document.getElementById('cart-loading-overlay').style.display = 'none';
          document.body.classList.remove('hide-drawer');
        }, 500);
    });
  } else { // switchItemToSubscriptionData
    await Rebuy.Cart.switchCartToFrequency(null, function() {
      // document.getElementById('cart-loading-overlay').style.display = 'none';
      // Keep overlay visible briefly after completion
      setTimeout(() => {
        document.getElementById('cart-loading-overlay').style.display = 'none';
        document.body.classList.remove('hide-drawer');
      }, 500);
    });
  }
});